import { createFileRoute, redirect } from '@tanstack/react-router';

/** TODO: remove it when GRANDVALIRA04 campaign ends  */
export const Route = createFileRoute('/www/ca/arrodoniment-solidari')({
	beforeLoad: () => {
		throw redirect({
			href: 'https://grandvaliraresorts.worldcoo.com/78c044cc-49fb-42cf-9b08-ba48cc75a7ed',
		});
	},
});
